<template>
  <div class="page-wrap">

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header__icon"><i class="fa fa-link"></i></div>
        <div class="panel-header__text">
          <div class="panel-header__title">Assign Services</div>
          <div class="panel-header__sub">{{ group.name || 'Loading group…' }}</div>
        </div>
        <div class="panel-header__action">
          <button class="btn-back" @click="$router.go(-1)">
            <i class="fa fa-arrow-left"></i> Back
          </button>
        </div>
      </div>

      <!-- Sticky add-service toolbar -->
      <div class="toolbar">
        <div class="toolbar__select">
          <multiselect
            :key="1"
            :options="serviceservices"
            placeholder="Search and add a service…"
            label="name"
            :custom-label="nameWithLang"
            track-by="id"
            @input="draggableArray"
          ></multiselect>
        </div>
        <button
          class="btn-update"
          v-if="services.length > 0"
          ref="kt_update_note"
          @click="storeUpdate"
        >
          <i class="fa fa-save"></i> Update
        </button>
      </div>

      <!-- Loading -->
      <div class="tbl-loading" v-if="loadingData">
        <div class="tbl-loading__spinner"></div>
        <span>Loading services…</span>
      </div>

      <!-- Table -->
      <div class="table-wrap" v-if="!loadingData">
        <table class="svc-table">
          <thead>
            <tr>
              <th class="th-drag"></th>
              <th>Service Name</th>
              <th class="th-center">Status</th>
              <th class="th-center">Drug Testing</th>
              <th class="th-action"></th>
            </tr>
          </thead>
          <draggable v-model="services" tag="tbody" handle=".drag-handle">
            <tr v-for="(item, index) in services" :key="item.id || item.name" class="svc-row">
              <td class="td-drag">
                <i class="fa fa-grip-vertical drag-handle"></i>
              </td>
              <td class="td-name">{{ item.name }}</td>
              <td class="td-center">
                <span class="status-pill status-pill--active" v-if="item.is_active">Active</span>
                <span class="status-pill status-pill--inactive" v-else>Inactive</span>
              </td>
              <td class="td-center">
                <i class="fa fa-check bool-yes" v-if="item.is_drug_testing"></i>
                <i class="fa fa-times bool-no" v-else></i>
              </td>
              <td class="td-action">
                <button class="btn-remove" @click="deleteItem(index)">
                  <i class="fa fa-times"></i>
                </button>
              </td>
            </tr>
          </draggable>
        </table>

        <!-- Empty state -->
        <div class="empty-state" v-if="services.length === 0">
          <i class="fa fa-link empty-state__icon"></i>
          <div class="empty-state__title">No services assigned</div>
          <div class="empty-state__sub">Use the search above to add services to this group</div>
        </div>
      </div>

    </div>

    <!-- Floating save bar -->
    <div class="save-bar" v-if="services.length > 0">
      <button class="save-bar__back" @click="$router.go(-1)">
        <i class="fa fa-arrow-left"></i> Back
      </button>
      <div class="save-bar__right">
        <button class="save-bar__update" ref="kt_update_note" @click="storeUpdate">
          <i class="fa fa-save"></i> Update
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import {
  FETCH_B_SERVICES,
  CREATE_GROUP_SERVICE,
  GET_GROUP
} from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import draggable from "vuedraggable";

export default {
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.$store.dispatch(FETCH_B_SERVICES).then(res => {
      this.serviceservices = res.data;
    });
    this.$store.dispatch(GET_GROUP, this.$route.params.id).then(res => {
      this.services = res.services;
      this.group = res.group;
    });
  },
  components: { Multiselect, draggable },
  methods: {
    nameWithLang({ name }) {
      return `${name}`;
    },
    draggableArray(val) {
      const exists = this.services.some(w => w.id === val.id);
      if (exists) {
        this.$toastr.w("Service already added");
      } else {
        this.services.push({ ...val });
      }
    },
    deleteItem(i) {
      this.services.splice(i, 1);
    },
    storeUpdate() {
      let data = { id: this.$route.params.id, data: this.services };
      this.$store
        .dispatch(CREATE_GROUP_SERVICE, data)
        .then(() => {
          this.$toastr.s("Services updated successfully");
          this.$store.dispatch(GET_GROUP, this.$route.params.id).then(res => {
            this.services = res.services;
            this.group = res.group;
          });
        })
        .catch(() => {
          this.$toastr.e("Something went wrong");
        });
    }
  },
  data() {
    return {
      loadingData: false,
      services: [],
      group: {},
      serviceservices: [],
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Group List",    route: "client.groups" },
        { id: 3, title: "Group Service", route: "" }
      ]
    };
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$green:  #276749;
$border: #dde2ec;

@keyframes spin { to { transform: rotate(360deg); } }

.page-wrap {
  padding: 12px 12px 80px;
  font-family: $font;
}

/* ── panel card ── */
.panel-card {
  background: #fff;
  border: 1px solid $border;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* ── header ── */
.panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid $border;
  background: linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%);

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, $blue, #2277aa);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    flex-shrink: 0;
  }

  &__text { flex: 1; }
  &__title { font-size: 16px; font-weight: 700; color: $dark; line-height: 1.2; }
  &__sub   { font-size: 12px; color: #7a8499; margin-top: 3px; }
  &__action { flex-shrink: 0; }
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f0f3fa;
  color: $dark;
  border: 1.5px solid $border;
  border-radius: 8px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  transition: background 0.15s;
  &:hover { background: #e4eaf5; }
}

/* ── toolbar ── */
.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid $border;
  background: #fafbfd;
  position: sticky;
  top: 0;
  z-index: 10;

  &__select { flex: 1; max-width: 420px; }
}

.btn-update {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: $blue;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, box-shadow 0.15s;
  &:hover { background: #2d85bb; box-shadow: 0 4px 12px rgba(56,154,212,0.3); }
}

/* ── multiselect overrides ── */
:deep(.multiselect) {
  font-family: $font;
  font-size: 13px;
}
:deep(.multiselect__tags) {
  border: 1.5px solid $border;
  border-radius: 9px;
  padding: 6px 12px;
  min-height: 38px;
}
:deep(.multiselect__tags):focus-within {
  border-color: $blue;
  box-shadow: 0 0 0 3px rgba(56,154,212,0.12);
}
:deep(.multiselect__placeholder) { color: #b0b8cc; font-size: 13px; }
:deep(.multiselect__option--highlight) { background: $blue; }
:deep(.multiselect__option--highlight::after) { background: $blue; }
:deep(.multiselect__input) { font-size: 13px; font-family: $font; }

/* ── loading ── */
.tbl-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 28px 24px;
  font-size: 13px;
  color: #7a8499;

  &__spinner {
    width: 18px;
    height: 18px;
    border: 2.5px solid #c5d8f5;
    border-top-color: $blue;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
    flex-shrink: 0;
  }
}

/* ── table ── */
.table-wrap {
  padding: 0 24px 24px;
  overflow-x: auto;
}

.svc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  color: $dark;

  th {
    padding: 10px 14px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #7a8499;
    border-bottom: 2px solid $border;
    white-space: nowrap;
    background: #fafbfd;
  }

  .th-drag   { width: 36px; }
  .th-center { text-align: center; }
  .th-action { width: 44px; }

  td {
    padding: 11px 14px;
    border-bottom: 1px solid #f0f2f8;
    vertical-align: middle;
  }

  .svc-row {
    transition: background 0.12s;
    &:hover { background: #f8fbff; }
    &:last-child td { border-bottom: none; }
  }

  .td-drag   { text-align: center; }
  .td-center { text-align: center; }
  .td-name   { font-weight: 400; }
  .td-action { text-align: right; padding-right: 10px; }
}

/* ── drag handle ── */
.drag-handle {
  color: #c5d0e0;
  cursor: grab;
  font-size: 13px;
  padding: 4px;
  &:active { cursor: grabbing; }
}

/* ── status pills ── */
.status-pill {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;

  &--active   { background: rgba(39,103,73,0.1);  color: $green; }
  &--inactive { background: rgba(160,170,184,0.12); color: #7a8499; }
}

/* ── bool icons ── */
.bool-yes { color: $green; font-size: 13px; }
.bool-no  { color: #d0d5e0; font-size: 13px; }

/* ── remove button ── */
.btn-remove {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #c0c8d8;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
  &:hover { background: #fff0f0; color: #b42318; }
}

/* ── empty state ── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px;
  gap: 10px;

  &__icon  { font-size: 36px; color: #c5d0e0; }
  &__title { font-size: 15px; font-weight: 600; color: $dark; }
  &__sub   { font-size: 13px; color: #7a8499; }
}

/* ── floating save bar ── */
.save-bar {
  position: fixed;
  bottom: 2.5rem;
  width: calc(78vw);
  left: 50%;
  transform: translateX(-40%);
  background: #1a2340;
  border-radius: 14px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 8px 32px rgba(13,27,62,0.3);
  z-index: 100;

  &__back {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: rgba(255,255,255,0.1);
    color: rgba(255,255,255,0.85);
    border: 1.5px solid rgba(255,255,255,0.15);
    border-radius: 9px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 500;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s;
    &:hover { background: rgba(255,255,255,0.18); }
  }

  &__right { display: flex; gap: 10px; }

  &__update {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: $blue;
    color: #fff;
    border: none;
    border-radius: 9px;
    padding: 9px 22px;
    font-size: 13px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    transition: background 0.15s, box-shadow 0.15s;
    &:hover { background: #2d85bb; box-shadow: 0 4px 14px rgba(56,154,212,0.4); }
  }
}
</style>
